import { combineReducers } from 'redux';

import { SET_SUBSCRIPTION_END_DATE } from '../actions/addons';

const subscriptionEndDate = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SUBSCRIPTION_END_DATE) {
        nextState = payload;
    }

    return nextState;
};

export default combineReducers({
    subscriptionEndDate,
});
